import type React from 'react';
import type { IconName } from './ui';

// WU-RECV: the ways a recipient can get the money, in the order the section shows them. Cash is first and
// selected by default (Zerayacob, 2 Nov 2026). Bank transfer is not live yet: it is shown as "Coming soon".
export type ReceiveOptionKey = 'cash' | 'mobile' | 'bank';

export type ReceiveOption = {
  key: ReceiveOptionKey;
  icon: IconName;
  available: boolean;
  /** A product image for the preview panel, later. Until then the panel draws the icon. */
  media?: React.ReactNode;
};

export const RECEIVE_OPTIONS: ReceiveOption[] = [
  { key: 'cash', icon: 'cash', available: true },
  { key: 'mobile', icon: 'phone', available: true },
  { key: 'bank', icon: 'bank', available: false },
];
